export default {
     'attack':'attack',
     'defense':'defense',
     'health':'health',
     'farm':'farm',
     'other':'other',
}